import React from "react";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import NewWorkType from "./NewWorkType";
import {useDispatch, useSelector} from "react-redux";
import {useWorkTypeData} from "../../../hooks/useWorkTypeData";
import {getDataFresh, getWorkTypeData} from "../../../state/selectors";
import WorkTypeRow from "./WorkTypeRow";
import {createSetWorkTypeDataAction} from "../../../actions/dataActions";
import LoadingSpinner from "../../Utils/Spinner";


export default function WorkTypeView(props){
    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);
    let loading = useWorkTypeData({}, dataFresh);
    let data = useSelector(getWorkTypeData);



    const onWorkTypeUpdate = (index, newWorkType) => {
        let newResults = [...data.results]
        let newState = {...data, results: newResults};
        newState.results[index] = newWorkType;
        dispatch(createSetWorkTypeDataAction(newState));
    }

    if(!loading){
        return(
            <LoadingSpinner/>
        );
    }


    return (
        <div>
            <NewWorkType/>
            <Box>
                <details>
                    <summary><Title>Workshop Expense Charge Type</Title></summary>
                    <Columns isMultiline>
                        <Column>
                            <p className={"bold"}>Note:</p>
                            <ul>
                                <li>Free of charge allows work items to skip workshop expenses (they still go to customer invoicing)</li>
                                <li>Approval Required forces an extra approval step (approval received) on work items before they can be approved on workshop expenses</li>
                                <li>Should Claim For Warranty adds an extra step to workshop expenses before approval needed where a warranty claim needs to be issued on a third party system</li>
                            </ul>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Table
                                isFullwidth
                            >
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Free of Charge Work</th>
                                        <th>Approval Needed</th>
                                        <th>Should Claim for Warranty</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.results.map((workType, index) => (
                                        <WorkTypeRow
                                            key={workType.id}
                                            workTypeData={workType}
                                            index={index}
                                            dataFresh={dataFresh}
                                            onUpdate={onWorkTypeUpdate}
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                </details>
            </Box>
        </div>
    );



}